import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  favorite: {
    byId: {}
  },
  actionsloading: false
});

export function calendarReducer(state = initialState, action) {
  // console.log('in calendar reduecer....', action)
  switch (action.type) {
    case actionTypes.FETCH_COLLECTION:
    case actionTypes.FETCH_ONE:
    case actionTypes.SAVE_FAVORITE:
    case actionTypes.REMOVE_FAVORITE:
    case actionTypes.GET_FAVORITES:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_ONE_SUCCESS:
    case actionTypes.FETCH_COLLECTION_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false
      }
    case actionTypes.SAVE_FAVORITE_SUCCESS:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          byId: {
            ...state.favorite.byId,
            [action.payload.favoriteUid]: action.payload
          }
        },
        actionsloading: false
      }
    case actionTypes.REMOVE_FAVORITE_SUCCESS:
      Object.keys(state.favorite.byId).forEach(function (key, index) {
        console.log(key)
        if (state.favorite.byId[key].favoriteUid === action.payload.id) {
          console.log('match......', action.payload.id)
          delete state.favorite.byId[key]
        } else {
          console.log('33333')
        }
      })
      return {
        ...state,
        favorite: {
          ...state.favorite,
          byId: state.favorite.byId || {},
        },
        actionsloading: false
      }
    case actionTypes.GET_FAVORITES_SUCCESS:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          byId: action.payload.byId || {},
        },
        actionsloading: false
      }
    default:
      return state;
  }
}